'use client';
import React from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  stat?: { value: string; label: string };
  action?: React.ReactNode;
}

export default function PageHeader({ eyebrow, title, description, stat, action }: PageHeaderProps) {
  return (
    <div style={{ background: '#0C0A16', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-5">
          <div>
            {eyebrow && (
              <div
                className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full mb-3"
                style={{ background: 'rgba(76,201,255,0.08)', border: '1px solid rgba(76,201,255,0.15)' }}
              >
                <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#4CC9FF' }} />
                <span className="text-[11px] font-medium tracking-wide" style={{ color: '#4CC9FF' }}>
                  {eyebrow}
                </span>
              </div>
            )}
            <h1 className="font-display font-bold text-[30px] sm:text-[36px] leading-tight mb-2" style={{ color: '#F2F4FF' }}>
              {title}
            </h1>
            {description && (
              <p className="text-[15px] max-w-xl leading-relaxed" style={{ color: '#A7A3C4' }}>
                {description}
              </p>
            )}
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            {stat && (
              <div className="text-right">
                <div className="font-display font-bold text-[24px] tabular-nums" style={{ color: '#F2F4FF' }}>
                  {stat.value}
                </div>
                <div className="text-[12px]" style={{ color: '#A7A3C4' }}>{stat.label}</div>
              </div>
            )}
            {action}
          </div>
        </div>
      </div>
    </div>
  );
}
